import { render, staticRenderFns } from "./SortComponent.vue?vue&type=template&id=c062c0e0"
import script from "./SortComponent.vue?vue&type=script&lang=js"
export * from "./SortComponent.vue?vue&type=script&lang=js"
import style0 from "./SortComponent.vue?vue&type=style&index=0&id=c062c0e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports